import { Sheet } from "./Sheet";
import { useT } from "../../lib/LocaleContext";

export function DiaperSheet({
  open,
  onSubmit,
  onClose,
}: {
  open: boolean;
  onSubmit: (kind: "wet" | "dirty" | "both") => void;
  onClose: () => void;
}) {
  const t = useT();

  return (
    <Sheet open={open} onClose={onClose} title={t.diaperSheet.title}>
      <div className="diaper-grid">
        <button type="button" className="big-button" onClick={() => onSubmit("wet")}>
          <span className="big-button__icon" aria-hidden="true">💧</span>
          <span className="big-button__label">{t.diaperSheet.wet}</span>
        </button>
        <button type="button" className="big-button" onClick={() => onSubmit("dirty")}>
          <span className="big-button__icon" aria-hidden="true">💩</span>
          <span className="big-button__label">{t.diaperSheet.dirty}</span>
        </button>
        <button type="button" className="big-button" onClick={() => onSubmit("both")}>
          <span className="big-button__icon" aria-hidden="true">💧💩</span>
          <span className="big-button__label">{t.diaperSheet.both}</span>
        </button>
      </div>
    </Sheet>
  );
}
